/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeAccountStore from 'stores/AccountStore';

import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

type TypeProps = {|
  response: Object,
|};

type InjectedProps = {
  actionDrawerStore: TypeActionDrawerStore,
  accountStore: TypeAccountStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class MarkAsDefaultLocationSuccess extends ComponentWithInjectedProps<
  TypeProps,
  {},
  InjectedProps
> {
  async componentDidMount() {
    const { accountStore, actionDrawerStore } = this.props;
    accountStore.resetLocations();
    await accountStore.loadCompanies(accountStore.accountId);
    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Node {
    const { t, response } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:locations.mark_as_default_location')}</h3>
            <p>{t('general:locations.messages.marked_as_default')}</p>
            {response.company && (
              <ul>
                <li>
                  <b>{t('general:company')}</b>
                </li>
                <li>{response.company}</li>
              </ul>
            )}
            {response.site && (
              <ul>
                <li>
                  <b>{t('general:locations.labels.site')}</b>
                </li>
                <li>{response.site}</li>
              </ul>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
